import React, { lazy, Suspense, useEffect } from 'react';
import LoadingScreen from './LoadingScreen';
const MangaonPageContent = lazy(()=>import('./MangaonPageContent'));
const ProjectsNavbar = lazy(()=>import('./ProjectsNavbar'));
const Footer = lazy(()=>import('./Footer'));
const SubFooter = lazy(()=>import("./SubFooter"));
const Enquiry = lazy(()=>import("./Enquiry"));

export default function MangaonPage() {
    useEffect(()=>{
        window.scroll(0,0);
      },[]);
      return (
        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 row px-0 display-flex'>
            <Suspense fallback={<LoadingScreen />}>
              <ProjectsNavbar buttonOptions={[
                {label:"know us" , hrefLink:"#knowus"},
                {label:"Why US" , hrefLink:"#whyus"},
                {label:"Offers" , hrefLink:"#offers"},
                {label:"Amenities" , hrefLink:"#amenities"},
                {label:"Gallery" , hrefLink:"#gallery"},
                {label:"Projects" , hrefLink:"/projects"},

              ]} />
                <MangaonPageContent />
                <SubFooter />
                <Footer />
                <Enquiry originOfEnquiry = "MANGAON - MAHARASHTRA" />
            </Suspense>
        </div>
  )
}
